import { useEffect, useState } from 'react';
import { TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG } from '../../../../../../constants/constant';
import {
  CUSTOMER_NOTES_ITEMS_PER_PAGE,
  NOTES_HEADER_KEYS,
  NOTES_RECORD_KEYS,
} from '../../../customer-detail/constants';
import ViewAllNotesModals from '../../../modals/customerDetailAction/viewAllNotes';
import NoteModal from '../../../modals/orderDetails/addNewNote';
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from '../../../ui/card';
import { Table, TableColumnConfig } from '../../../ui/customTable/Table';
import Pagination from '../../../utils/pagination';
import { OrderNotesOptions } from '../../constant';
import { PageTexts } from '../../i18n';
import { FormattedNoteType } from '../../types';

export const OrderNotesTableHeadersInfo: TableColumnConfig<any>[] = [
  {
    key: NOTES_RECORD_KEYS.AGENT,
    header: NOTES_HEADER_KEYS.AGENT,
    render: (data) => {
      return <div className="gbmask">{data?.split('@')?.[0]}</div>;
    },
  },
  {
    key: NOTES_RECORD_KEYS.DATE_TIME,
    header: NOTES_HEADER_KEYS.ORDER_DATE_TIME,
    render: (data) => {
      return <div className="whitespace-nowrap">{data}</div>;
    },
  },
  {
    key: NOTES_RECORD_KEYS.NOTES,
    header: NOTES_HEADER_KEYS.NOTES,
    render: (data) => {
      return <div className="gbmask">{data}</div>;
    },
  },
];

const OrderNotes = ({
  totalNotes,
  notes,
  addNewNotes,
  showActiveBrandSection = true,
}: {
  totalNotes: number;
  notes: FormattedNoteType;
  addNewNotes: any;
  showActiveBrandSection?: boolean;
}) => {
  const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);
  const [currentPageNotes, setCurrentPageNotes] = useState(notes);
  const [currentPage, setCurrentPage] = useState(1);

  const onPageChange = async (page: number) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * 5;
    const endIndex = startIndex + 5;
    setCurrentPageNotes(notes?.slice(startIndex, endIndex));
  };

  useEffect(() => {
    setCurrentPageNotes(notes);
    onPageChange(1);
  }, [notes]);

  return (
    <Card className="w-full rounded-md border-foggyGray shadow-lg">
      <CardHeader className="p-5">
        <CardTitle className="mb-2 flex flex-wrap items-center">
          <p className="mr-auto text-lg font-bold">
            {Texts.orderNotesHeading} ({totalNotes})
          </p>
          <div className="mr-2 h-[30px] rounded-md border-[1px] border-foggyGray px-4 py-1.5 text-xs font-medium">
            <ViewAllNotesModals
              customerNotes={notes}
              noteOptions={OrderNotesOptions}
              addNewNotes={addNewNotes}
              showActiveBrandSection={showActiveBrandSection}
            />
          </div>
          {showActiveBrandSection && (
            <NoteModal Texts={Texts} flag noteOptions={OrderNotesOptions} addNewNotes={addNewNotes} />
          )}
        </CardTitle>
        <CardContent className="p-0">
          <Table columns={OrderNotesTableHeadersInfo} data={currentPageNotes?.slice(0, 5)} />
        </CardContent>
      </CardHeader>
      <CardFooter>
        <section className="flex w-full items-center justify-end">
          <div className="flex items-center">
            <Pagination
              currentPage={currentPage}
              itemsPerPage={CUSTOMER_NOTES_ITEMS_PER_PAGE}
              totalItems={totalNotes}
              onPageChange={onPageChange}
            ></Pagination>
          </div>
        </section>
      </CardFooter>
    </Card>
  );
};

export default OrderNotes;
